var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page-styleguide"},[_c('section',{attrs:{"id":"typography"}},[_c('h1',[_vm._v("Heading #1")]),_c('h2',[_vm._v("Heading #2")]),_c('h3',[_vm._v("Heading #3")]),_c('h4',[_vm._v("Heading #4")]),_c('h5',[_vm._v("Heading #5")]),_c('h6',[_vm._v("Heading #6")])])])
}]

export { render, staticRenderFns }